import {
    useState,
    useContext,
    useCallback,
    useImperativeHandle,
    useEffect,
    forwardRef,
} from "react";
import styled from "styled-components";
import _ from "lodash";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import { Form } from "../../components/share";
import { DeliveryFields, LoginHistoryFields } from "./formFields";
import { getDirtyValues } from "../../utils";
import { CircularProgress, Box } from "@mui/material";
import Joi from "joi";
import { joiResolver } from "@hookform/resolvers/joi";

const schema = Joi.object({
    fromDate: Joi.string().required(),
    toDate: Joi.string().required(),
}).messages({
    "any.required": "Required",
});

const LoginHistory = forwardRef((props, ref) => {
    const { isLoading, setSnackbar, permission, onSubmit } = props;

    const {
        control,
        handleSubmit,
        watch,
        formState: { errors, dirtyFields },
    } = useForm({
        resolver: joiResolver(schema),
    });

    const handleOnSubmit = (formValue) => {
        if (_.isEmpty(dirtyFields)) {
            return setSnackbar({
                type: "success",
                message: "Success",
            });
        }

        // Check range between fromDate and toDate. If between is more than 1 year, show error
        const fromDate = new Date(formValue.fromDate);
        const toDate = new Date(formValue.toDate);

        if (toDate - fromDate > 365 * 24 * 60 * 60 * 1000) {
            return setSnackbar({
                type: "error",
                message: "Date range cannot be more than 1 year",
            });
        }

        const dirty = getDirtyValues(dirtyFields, formValue);
        onSubmit && onSubmit(dirty);
    };

    useImperativeHandle(ref, () => ({
        onSubmit: () => handleSubmit(handleOnSubmit)(),
    }));

    if (isLoading) {
        return (
            <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                height="100％"
            ></Box>
        );
    }

    return (
        <Form
            fields={LoginHistoryFields({
                control,
                errors: errors,
                readOnly: !permission?.canView,
                fromDate: watch("fromDate"),
                toDate: watch("toDate"),
            })}
            p={`14px 0px`}
        />
    );
});

export default LoginHistory;
